import type { CSSProperties } from 'react';

interface Props {
  /** Pixel height of the rendered wordmark. The image keeps its aspect ratio. */
  height?: number;
  /** White variant for the dark sidebar / brand panel; red everywhere else. */
  variant?: 'default' | 'on-dark';
  className?: string;
}

/**
 * Wheels wordmark — the real brand asset in its two official colourways:
 * /wlogo-red.png on light backgrounds, /wlogo-white.png on dark. No CSS
 * filters and no styled-text fallback (the brand is the image).
 */
export function Logo({ height = 28, variant = 'default', className }: Props) {
  const imgStyle: CSSProperties = {
    height,
    width: 'auto',
    display: 'block',
    objectFit: 'contain',
  };

  return (
    <img
      src={variant === 'on-dark' ? '/wlogo-white.png' : '/wlogo-red.png'}
      alt="Wheels"
      style={imgStyle}
      className={className}
      draggable={false}
    />
  );
}
